import RegistrationHero from './RegistrationHero';

export default RegistrationHero;
